import React, { Component } from 'react'
import { Redirect } from 'react-router-dom'

class Default extends Component {
  
  render () {
    return <Redirect to='/app' />
  }
}
export default Default